import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,

        dataTableOptions: {
            server_mode: true,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        searchFields: [
            {
                name: "nev",
                label: "Név",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "jogcim",
                label: "Jogcím",
                formSize: 2,
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getJogcimList,
                    formatText: function(val){
                        return val.text;
                    },
                    formatOption: function(val){
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "termekkod",
                label: "Típus",
                formSize: 3,
                formVisible: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getTermekkodList,
                    formatText: function(val){
                        return val.leiras;
                    },
                    formatOption: function(val){
                        return val.leiras;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'szovegkod',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "hatoanyag",
                label: "Hatóanyag",
                formSize: 2,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "ttt",
                label: "TTT kód",
                formSize: 2,
                formVisible: true,
                formType: 'text'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'seeRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false,
                formType: 'text',
            },
            {
                name: "ttt",
                label: "TTT kód",
                visibility: true
            },
            {
                name: "nev",
                label: "Termék neve",
                visibility: true,
                sort: true,
                slot_name: "puphaXTermekszinezes"
            },
            {
                name: "hatoanyag",
                label: "Hatóanyag",
                visibility: true,
                sort: true
            },
            {
                name: "kisznev",
                label: "Kiszerelés",
                visibility: true
            },
            {
                name: "termekkodText.leiras",
                label: "Típus",
                visibility: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        headerFieldsDrugEquiv: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false,
                formType: 'text',
            },
            {
                name: "ttt",
                label: "TTT kód",
                visibility: true,
            },
            {
                name: "nev",
                label: "Termék neve",
                visibility: true,
                slot_name: "puphaXTermekszinezes"
            },
            {
                name: "hatoanyag",
                label: "Hatóanyag",
                visibility: true
            },
            {
                name: "kisznev",
                label: "Kiszerelés",
                visibility: true
            },
            {
                name: "termekkodText.leiras",
                label: "Típus",
                visibility: true
            }
        ],
        formFields: [
            {
                name: "ttt",
                label: "TTT kód",
                formVisible: true,
                formSize: 1,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "nev",
                label: "Termék neve",
                formVisible: true,
                formSize: 3,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "hatoanyag",
                label: "Hatóanyag",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "kisznev",
                label: "Kiszerelés",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },

            {
                name: "gyforma",
                label: "Gyógyszerforma",
                formVisible: true,
                formSize: 1,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "kiszMenny",
                label: "Kiszerelési egységek száma",
                formVisible: true,
                formSize: 1,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "kiszEgys",
                label: "Kiszerelési egység egységneve",
                formVisible: true,
                formSize: 1,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "adagMod",
                label: "Adagolás módja",
                formVisible: true,
                formSize: 1,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "dot",
                label: "Hány napra elegendő a WHO szerint",
                formVisible: true,
                formSize: 1,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "adagEgys",
                label: "Adagolás mennyiség egysége",
                formVisible: true,
                formSize: 1,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "adagMenny",
                label: "Hány adag. menny. egys.-nek megfelelő mennyiséget tartalmaz",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "termekkodTextLeiras",
                label: "Típus",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "rendelhetoseg",
                label: "Rendelhetőség",
                formVisible: true,
                formSize: 4,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "helyettesith",
                label: "Helyettesíthetőség",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "tk",
                label: "OGYI törzskönyvi szám",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "eankod",
                label: "EAN kód",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "atc",
                label: "ATC kód",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "ISO",
                label: "ISO kód",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "potencia",
                label: "Potencia",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "ohatoMenny",
                label: "Összes hatóanyag tartalom",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "hatoMenny",
                label: "Egy kiszerelési egységben levő hatóanyag tartalom",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "hatoEegys",
                label: "Hatóanyag mennyiségi egysége",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "dddMenny",
                label: "DDD mennyiség",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "dddEgys",
                label: "DDD mennyiségi egysége",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "dddFaktor",
                label: "hatóa. menny. egys. és DDD menny. egys. közti átváltó szám",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "egyedi",
                label: "Egyedi méretvétel alapján készül-e a termék",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "oldalisag",
                label: "Értelmezhető-e az oldaliság jelölése",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "tobblgar",
                label: "Többletgarancia",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "patika",
                label: "Patikában is kapható",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "dobazon",
                label: "Doboz azonosítót kötelező-e megadni",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "keresztjelzes",
                label: "OGYI hatáserősség (méregosztály) jelzése",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            },
            {
                name: "forgalomban",
                label: "Forgalomban van-e",
                formVisible: true,
                formSize: 2,
                formType: 'text',
                formReadOnly: true
            }
        ],

        tamalapRowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'seeTamalapRow'
            }
        ],
        tamalapHeaderFields: [
            {
                name: "termar",
                label: "Termelői ár",
                slot_name: "currencyFormat1",
                visibility: true
            },
            {
                name: "nkar",
                label: "Nagykereskedelmi ár",
                slot_name: "currencyFormat2",
                visibility: true
            },
            {
                name: "fan",
                label: "Fogy. ár (nettó)",
                slot_name: "currencyFormat3",
                visibility: true
            },
            {
                name: "fab",
                label: "Fogy. ár (bruttó)",
                slot_name: "currencyFormat4",
                visibility: true
            },
            {
                name: "maxfab",
                label: "Maximált bruttó fogy. ár",
                slot_name: "currencyFormat5",
                visibility: true
            },
            {
                name: "afa",
                label: "ÁFA",
                visibility: true
            },
            {
                name: "ntk",
                label: "Napi terápiás költség",
                slot_name: "currencyFormat6",
                visibility: true
            },
            {
                name: "egysegar",
                label: "Egységár",
                visibility: true
            },
            {
                name: "besorolas",
                label: "Költséghatékonysági kat. kódja jogcímenkénz",
                visibility: false
            },
            {
                name: "prasTermek",
                label: "PReferált ÁrSávba (PRAS) tartozó termék jelölése",
                visibility: true
            },
            {
                name: "kestTerm",
                label: "Kedvezményezett státuszú termék jelölése",
                visibility: true,
                slot_name: "formatCheckByZeroOrOne1"
            },
            {
                name: "kgykeret",
                label: "Közgyógy keretre írhatóság",
                visibility: true,
                slot_name: "formatCheckByZeroOrOne2"
            },
            {
                name: "kulonl100",
                label: "100%-os támogatási kategóriák felírhatósága",
                visibility: true,
                slot_name: "formatKulonl100"
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],

        kategtamRowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'seeEupontokRow'
            }
        ],
        kategtamHeaderFields: [
            {
                name: "kategoriaText.leiras",
                label: "Támogatási kategória",
                visibility: true
            },
            {
                name: "tamtechn",
                label: "Támogatás technikája",
                visibility: true,
                slot_name: "tamtechnFormat"
            },
            {
                name: "kgyirhato",
                label: "Közgyógyra írhatóság",
                visibility: true,
                slot_name: "formatCheckByZeroOrOne1"
            },
            {
                name: "minEletkor",
                label: "Életkor feltétel (min)",
                visibility: true
            },
            {
                name: "maxEletkor",
                label: "Életkor feltétel (max)",
                visibility: true
            },
            {
                name: "nem",
                label: "Nemre vonaktozó megkötés",
                visibility: true,
                slot_name: "formatMaleOrFemale"
            },
            {
                name: "tamszaz",
                label: "Támogatás mértéke (%)",
                visibility: true
            },
            {
                name: "fixId",
                label: "Fixcsoport azonosítója",
                visibility: true
            },
            {
                name: "refntk",
                label: "Fixcsoport referencia NTK-ja",
                visibility: true
            },
            {
                name: "ntam",
                label: "Nettó támogatás",
                visibility: true,
                slot_name: "currencyFormat1"
            },
            {
                name: "btam",
                label: "Bruttó támogatás",
                visibility: true,
                slot_name: "currencyFormat2"
            },
            {
                name: "terdij",
                label: "Térítési díj",
                visibility: true,
                slot_name: "currencyFormat3"
            },
            {
                name: "ntktd",
                label: "Napi terápiás költség",
                visibility: true,
                slot_name: "currencyFormat4"
            },
            {
                name: "mihaid",
                label: "Csoportazonosító",
                visibility: true,
                slot_name: "mihaidFormat"
            },
            {
                name: "mihacel",
                label: "Minőségi és Hatékony Gyógyszerrendelési Ösztönzés - a gyógyszer csoportjának célértéke",
                visibility: false
            },
            {
                name: "mihastat",
                label: "Gyógyszer státusza",
                visibility: true,
                slot_name: "mihastatFormat"
            },
            {
                name: "kihi",
                label: "Kihordási idő",
                visibility: true
            },
            {
                name: "felme",
                label: "Felírható mennyiség",
                visibility: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],

        eupontokRowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'seeEupontokDetailsRow'
            }
        ],
        eupontokHeaderFields: [
            {
                name: "pontszam",
                label: "Indikáció kódja (per-jel előtti rész)",
                visibility: true
            },
            {
                name: "perjelzes",
                label: "Indikáció kódja (per-jel utáni rész)",
                visibility: true
            },
            {
                name: "feliras",
                label: "Felírási megjegyzések",
                visibility: true
            },
            {
                name: "megjegyzes",
                label: "Egyéb rendelhetőségi feltételek",
                visibility: true
            },
            {
                name: "indikaciok",
                label: "EÜ indikációk",
                visibility: true,
                slot_name: "indikaciokFormat"
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],

        bnokodokHeaderFields: [
            {
                name: "kod",
                label: "Kód",
                visibility: true
            },
            {
                name: "leiras",
                label: "Leírás",
                visibility: true
            }
        ],

        eujoghozzarHeaderFields: [
            {
                name: "kategoriaText.leiras",
                label: "Felírási megkötés típusa",
                visibility: true,
                slot_name: "kategoriaPuphaxFormat"
            },
            {
                name: "jogosultText.szovegkod",
                label: "Felírási jogosultság",
                visibility: true
            },
            {
                name: "jidokorlat",
                label: "A javaslattól kezdve hány hónapig írhatja az adott orvos a készítményt",
                visibility: true
            },
            {
                name: "szakvkodok.leiras",
                label: "Szükséges szakképesítés",
                visibility: true
            }
        ]
    }
}
